const wrapperSkin = {
  wrapper: {
    composes: "border table-auto",
    width: "100%",
  },
};

export default wrapperSkin;
